import { createContext, useContext } from 'react';

export const VisitorCountryContext = createContext(null);
export const useVisitorCountry = () => useContext(VisitorCountryContext);
